import { useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleHero from "./components/ArticleHero";
import ArticleBody from "./components/ArticleBody";
import ArticleRelated from "./components/ArticleRelated";
import { useEditorialPost, useEditorial } from "@/hooks/useEditorial";
import { Link } from "react-router-dom";

export default function EditorialDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const { post, loading: postLoading } = useEditorialPost(slug ?? "");
  const { posts, loading: postsLoading } = useEditorial();

  if (postLoading || postsLoading) {
    return (
      <div className="min-h-screen flex flex-col" style={{ fontFamily: "'Jost', sans-serif" }}>
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <p className="text-sm tracking-widest uppercase text-midnight/40 animate-pulse">Loading...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen flex flex-col" style={{ fontFamily: "'Jost', sans-serif" }}>
        <Navbar />
        <div className="flex-1 flex flex-col items-center justify-center gap-6 text-midnight/50">
          <p
            className="text-4xl font-light italic"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Article not found
          </p>
          <Link
            to="/"
            className="text-xs tracking-widest uppercase hover:text-midnight transition-colors flex items-center gap-1.5 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" /> Return Home
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-moonlight" style={{ fontFamily: "'Jost', sans-serif" }}>
      <Navbar />

      {/* Hero */}
      <ArticleHero post={post} />

      {/* Body */}
      <div className="max-w-3xl mx-auto">
        <ArticleBody blocks={post.body} />
      </div>

      {/* Share + tag row */}
      <div className="max-w-3xl mx-auto px-6 lg:px-0 pb-14 flex items-center justify-between border-t border-midnight/10 pt-8">
        <div className="flex items-center gap-2">
          <span className="text-[9px] tracking-widest uppercase text-midnight/40">Filed under</span>
          <span className="text-[9px] tracking-widest uppercase bg-midnight/8 text-midnight px-2.5 py-1 border border-midnight/15">
            {post.tag}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-[9px] tracking-widest uppercase text-midnight/40">Share</span>
          <button
            className="w-8 h-8 flex items-center justify-center text-midnight/40 hover:text-midnight transition-colors cursor-pointer"
            aria-label="Share on Pinterest"
          >
            <i className="ri-pinterest-line text-base" />
          </button>
          <button
            className="w-8 h-8 flex items-center justify-center text-midnight/40 hover:text-midnight transition-colors cursor-pointer"
            aria-label="Share on Instagram"
          >
            <i className="ri-instagram-line text-base" />
          </button>
          <button
            className="w-8 h-8 flex items-center justify-center text-midnight/40 hover:text-midnight transition-colors cursor-pointer"
            aria-label="Copy link"
          >
            <i className="ri-links-line text-base" />
          </button>
        </div>
      </div>

      {/* Related articles */}
      <ArticleRelated posts={posts} currentSlug={post.slug} />

      <Footer />
    </div>
  );
}
